export default function QRCodeSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-50 via-white to-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          <div className="grid lg:grid-cols-2 gap-0">
            {/* Left Side - Registration QR Code */}
            <div className="bg-gradient-to-br from-teal-500 to-teal-600 p-12 flex flex-col items-center justify-center">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-white mb-3">
                  Quét Mã QR Để Đăng Ký
                </h2>
                <p className="text-teal-50 text-lg">
                  Nhanh chóng và tiện lợi
                </p>
              </div>

              {/* Registration QR Code */}
              <div className="bg-white p-6 rounded-2xl shadow-xl mb-6">
                <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=280x280&data=${encodeURIComponent('https://readdy.ai' + __BASE_PATH__ + '/register-personal-brand')}`}
                  alt="QR Code đăng ký"
                  className="w-70 h-70"
                />
              </div>

              <div className="text-center">
                <p className="text-white font-medium mb-2">
                  Hoặc liên hệ trực tiếp qua Zalo
                </p>
                <div className="flex flex-col space-y-2">
                  <a
                    href="https://zalo.me/0902730008"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center space-x-2 bg-white text-teal-600 font-bold px-6 py-3 rounded-lg hover:bg-teal-50 transition-all whitespace-nowrap"
                  >
                    <i className="ri-chat-4-line text-xl"></i>
                    <span>0902 730 008</span>
                  </a>
                  <a
                    href="https://zalo.me/0902768879"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center space-x-2 bg-white text-teal-600 font-bold px-6 py-3 rounded-lg hover:bg-teal-50 transition-all whitespace-nowrap"
                  >
                    <i className="ri-chat-4-line text-xl"></i>
                    <span>0902 768 879</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Right Side - Payment QR Code */}
            <div className="bg-gradient-to-br from-amber-500 to-rose-500 p-12 flex flex-col items-center justify-center">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-white mb-3">
                  Quét Mã QR Thanh Toán
                </h2>
                <p className="text-amber-50 text-lg">
                  Chuyển khoản nhanh chóng
                </p>
              </div>

              {/* Payment QR Code */}
              <div className="bg-white p-6 rounded-2xl shadow-xl mb-6">
                <img
                  src="https://static.readdy.ai/image/5705871e133a048fcd13b20b6e4d74bd/0156547ffba72cad001aac2c2d909b8d.jpeg"
                  alt="QR Code thanh toán VietinBank"
                  className="w-70 h-70"
                />
              </div>

              <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6 text-center">
                <div className="text-white space-y-2">
                  <p className="font-bold text-lg">DOAN MINH HOANG</p>
                  <p className="text-amber-50">Tài khoản: 108872529945</p>
                  <p className="text-sm text-amber-100">VietinBank CN DONG NAI - HOI SO</p>
                </div>
                <div className="mt-4 pt-4 border-t border-white/30">
                  <p className="text-white font-bold text-2xl">70.000đ</p>
                  <p className="text-amber-100 text-sm mt-1">Nội dung: Họ tên + SĐT</p>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Info Section */}
          <div className="p-12 bg-gradient-to-r from-teal-50 to-amber-50">
            <div className="grid md:grid-cols-2 gap-8">
              {/* Pricing Info */}
              <div>
                <div className="inline-flex items-center space-x-2 bg-rose-100 text-rose-700 px-4 py-2 rounded-full mb-4">
                  <i className="ri-fire-fill"></i>
                  <span className="font-bold text-sm whitespace-nowrap">ƯU ĐÃI ĐẶC BIỆT</span>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  Chỉ Còn 70.000đ
                </h3>
                <div className="flex items-center space-x-4 mb-6">
                  <span className="text-2xl text-gray-400 line-through">500.000đ</span>
                  <span className="bg-rose-500 text-white font-bold px-4 py-2 rounded-lg whitespace-nowrap">
                    Tiết kiệm 430.000đ
                  </span>
                </div>

                <div className="space-y-3">
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-1"></i>
                    <p className="text-gray-700">
                      <strong>Thiết kế chuyên nghiệp</strong> - Giao diện đẹp mắt, hiện đại
                    </p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-1"></i>
                    <p className="text-gray-700">
                      <strong>Hoàn thành nhanh</strong> - Chỉ trong 3 ngày làm việc
                    </p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-1"></i>
                    <p className="text-gray-700">
                      <strong>Hỗ trợ tận tình</strong> - Đội ngũ chăm sóc 24/7
                    </p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-1"></i>
                    <p className="text-gray-700">
                      <strong>Tích hợp đầy đủ</strong> - Mạng xã hội, liên hệ, portfolio
                    </p>
                  </div>
                </div>
              </div>

              {/* Gift Info */}
              <div className="flex flex-col justify-center">
                <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-6 mb-6">
                  <div className="flex items-start space-x-3">
                    <i className="ri-gift-line text-amber-600 text-2xl flex-shrink-0"></i>
                    <div>
                      <h4 className="font-bold text-amber-900 mb-2">Quà Tặng Đặc Biệt</h4>
                      <ul className="text-sm text-amber-800 space-y-1">
                        <li>• Tên miền miễn phí trong 1 năm</li>
                        <li>• Hướng dẫn quản lý và cập nhật</li>
                        <li>• Tư vấn xây dựng thương hiệu</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-teal-50 border-2 border-teal-200 rounded-xl p-6">
                  <div className="flex items-start space-x-3">
                    <i className="ri-information-line text-teal-600 text-2xl flex-shrink-0"></i>
                    <div>
                      <h4 className="font-bold text-teal-900 mb-2">Hướng Dẫn Thanh Toán</h4>
                      <ul className="text-sm text-teal-800 space-y-1">
                        <li>1. Quét mã QR thanh toán bên trên</li>
                        <li>2. Nhập số tiền: <strong>70.000đ</strong></li>
                        <li>3. Nội dung: <strong>Họ tên + SĐT</strong></li>
                        <li>4. Xác nhận chuyển khoản</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}